import { APP_CONFIG } from '@/config';

/** Phone number plus Viber, Telegram and WhatsApp links (all on the same number). */
export function ContactLinks({ className = '' }: { className?: string }) {
  const { phone, phoneIntl } = APP_CONFIG.contact;
  const digits = phoneIntl.replace(/\D/g, '');
  const links = [
    { id: 'viber', label: 'Viber', href: `viber://chat?number=%2B${digits}` },
    { id: 'telegram', label: 'Telegram', href: `https://t.me/+${digits}` },
    { id: 'whatsapp', label: 'WhatsApp', href: `https://wa.me/${digits}` },
  ];
  return (
    <div className={`contact-links ${className}`}>
      <a className="contact-links__phone mono" href={`tel:${phoneIntl}`}>
        {phone}
      </a>
      <span className="contact-links__apps">
        {links.map((l) => (
          <a key={l.id} className={`contact-links__app contact-links__app--${l.id}`} href={l.href} target={l.id === 'viber' ? undefined : '_blank'} rel="noopener noreferrer">
            {l.label}
          </a>
        ))}
      </span>
    </div>
  );
}
